import LocalGrid from "./LocalGrid";

export default LocalGrid;
